export default __webpack_public_path__ + "static/media/FULFILLMENT_SERVICE.47d79c29.jpg";